import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, T4InvoiceLine } from 't4core';

@Component({
    selector: 't4-credit-invoice',
  templateUrl: './CreditInvoiceDialog.html',
  styleUrls: ['./CreditInvoiceDialog.css']
})
export class CreditInvoiceDialog extends DialogBase implements OnInit {
  public invoiceId: string;
  public invoiceLines: T4InvoiceLine[] = [];
  public comment: string;
  public isLoading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<CreditInvoiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("CreditInvoiceDialog");
    this.invoiceId = data.InvoiceId;
    this.invoiceLines = data.InvoiceLines;
  }

  public async ngOnInit() {
    this.isLoading = true;
    this.isLoading = false;
  }

  public async creditAmount() {
    if (!this.validateCreditAmounts()) {
      await this.UI.alert("Turbo.CreditInvoiceDialog.headValidateCreditFailed", "Validation failed", "Turbo.CreditInvoiceDialog.msgValidateCreditFailed", "The credit amount should not exceed the maximum amount limit.");
      return;
    }

    this.isLoading = true;
    var result = await this.Api.post<boolean>("/CC/CreditInvoiceLines", this.invoiceLines, { invoiceId: this.invoiceId, comment: this.comment });
    this.isLoading = false;
    if (result) {
      await this.UI.alert("Turbo.CreditInvoiceDialog.successCreditInvoice", "Invoice credited successfully", "Turbo.CreditInvoiceDialog.msgSuccessCreditInvoice", "The credit invoice is added successfully");
      this.dialogRef.close(true);
    }
    else {
      await this.UI.alert("Turbo.CreditInvoiceDialog.failedCreditInvoice", "Invoice credit failed", "Turbo.CreditInvoiceDialog.msgFailedCreditInvoice", "There was an issue with adding credit invoice. Please try again later.");
    }
  }


  public validateCreditAmounts(): boolean {
    for (const line of this.invoiceLines) {
      if ((line.Price - line.CreditedAmount) >= 0) {
        if (line.CreditAmount > (line.Price - line.CreditedAmount)) {
          return false;
        }
      }
      else {
        if (line.CreditAmount < (line.Price - line.CreditedAmount) || line.CreditAmount > 0) {
          return false;
        }
      }
    }
    return true;
  }
}
